module.exports = __webpack_public_path__ + "img/harvest_4.4736cf95.png";